import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import { get } from 'lodash';
import { paymentActions } from './actions';
import {
  BUNDLES_FAILURE,
  BUNDLES_REQUEST,
  BUNDLES_SUCCESS,
  PAYMENT_FAILURE,
  PAYMENT_REQUEST,
  PAYMENT_SUCCESS,
  PREMIUM_PAYMENT_SUCCESS,
  PAYMENT_INTENT_REQUEST,
  PAYMENT_INTENT_SUCCESS,
  PAYMENT_INTENT_FAILURE,
  PREMIUM_PAYMENT_INTENT_REQUEST,
  PREMIUM_PAYMENT_INTENT_SUCCESS,
  PREMIUM_PAYMENT_INTENT_FAILURE,
  STRIPE_FAILURE,
  STRIPE_SUCCESS,
  COUPON_PAYMENT_INTENT_SUCCESS,
  COUPON_PAYMENT_INTENT_REQUEST,
  COUPON_PAYMENT_INTENT_FAILURE,
  COUPON_PAYMENT_SUCCESS,
} from '../../constants/payments';

export type PaymentsState = {
  bundles: any;
  bundlesLoading: boolean;
  bundlesError: string | null;
  payment: any;
  paymentLoading: boolean;
  paymentIntentLoading: boolean;
  paymentError: string | null;
  paymentSecret: any;
  paymentSuccess: boolean;
};
export type PaymentsActions = ActionType<typeof paymentActions>;

export const paymentsReducer = combineReducers<PaymentsState, PaymentsActions>({
  bundles: (state = null, action) => {
    switch (action.type) {
      case BUNDLES_SUCCESS:
        return get(action, ['payload', 'coins_packs'], []);
      default:
        return state;
    }
  },
  bundlesLoading: (state = false, action) => {
    switch (action.type) {
      case BUNDLES_REQUEST:
        return true;
      default:
        return false;
    }
  },
  bundlesError: (state = null, action) => {
    switch (action.type) {
      case BUNDLES_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
  payment: (state = null, action) => {
    switch (action.type) {
      case STRIPE_SUCCESS:
        return action;

      default:
        return state;
    }
  },

  paymentSecret: (state = null, action) => {
    switch (action.type) {
      case PAYMENT_INTENT_SUCCESS:
        return action.payload.coins_pack_purchase;
      case PREMIUM_PAYMENT_INTENT_SUCCESS:
        return action.payload.premium_plan_purchase;
      case COUPON_PAYMENT_INTENT_SUCCESS:
        return action.payload.purchase;
      case PAYMENT_FAILURE:
      case PREMIUM_PAYMENT_INTENT_FAILURE:
      case PAYMENT_INTENT_FAILURE:
      case PAYMENT_INTENT_REQUEST:
      case PREMIUM_PAYMENT_INTENT_REQUEST:
      case COUPON_PAYMENT_INTENT_REQUEST:
        return null;
      default:
        return state;
    }
  },

  paymentLoading: (state = false, action) => {
    switch (action.type) {
      case PAYMENT_INTENT_REQUEST:
      case PREMIUM_PAYMENT_INTENT_REQUEST:
      case COUPON_PAYMENT_INTENT_REQUEST:
      case PAYMENT_REQUEST:
        return true;
      case PAYMENT_SUCCESS:
      case PREMIUM_PAYMENT_SUCCESS:
      case COUPON_PAYMENT_SUCCESS:
        return false;
      case PAYMENT_FAILURE:
      case PREMIUM_PAYMENT_INTENT_FAILURE:
      case PAYMENT_INTENT_FAILURE:
      case COUPON_PAYMENT_INTENT_FAILURE:
        return false;
      default:
        return state;
    }
  },
  paymentIntentLoading: (state = false, action) => {
    switch (action.type) {
      case PAYMENT_INTENT_REQUEST:
      case PREMIUM_PAYMENT_INTENT_REQUEST:
      case COUPON_PAYMENT_INTENT_REQUEST:
        return true;
      case PAYMENT_INTENT_SUCCESS:
      case PREMIUM_PAYMENT_INTENT_SUCCESS:
      case PAYMENT_FAILURE:
      case PAYMENT_INTENT_FAILURE:
      case PREMIUM_PAYMENT_INTENT_FAILURE:
      case COUPON_PAYMENT_INTENT_SUCCESS:
      case COUPON_PAYMENT_INTENT_FAILURE:
        return false;
      default:
        return state;
    }
  },
  paymentSuccess: (state = false, action) => {
    switch (action.type) {
      case PREMIUM_PAYMENT_INTENT_REQUEST:
      case PREMIUM_PAYMENT_INTENT_FAILURE:
      case PAYMENT_FAILURE:
      case PAYMENT_REQUEST:
      case COUPON_PAYMENT_INTENT_REQUEST:
      case COUPON_PAYMENT_INTENT_FAILURE:
        return false;
      case PREMIUM_PAYMENT_SUCCESS:
      case PAYMENT_SUCCESS:
      case COUPON_PAYMENT_SUCCESS:
        return true;
      default:
        return state;
    }
  },
  paymentError: (state = null, action) => {
    switch (action.type) {
      case PAYMENT_FAILURE:
      case PREMIUM_PAYMENT_INTENT_FAILURE:
      case PAYMENT_INTENT_FAILURE:
      case STRIPE_FAILURE:
      case COUPON_PAYMENT_INTENT_FAILURE:
        return action.payload.message || action.payload.detail;

      default:
        return null;
    }
  },
});
